import { render, staticRenderFns } from "./AlertNote.vue?vue&type=template&id=6174d1b8"
import script from "./AlertNote.js?vue&type=script&lang=js&external"
export * from "./AlertNote.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports